import { render, staticRenderFns } from "./CourseSubscription.vue?vue&type=template&id=c05b3476&scoped=true&"
import script from "./CourseSubscription.vue?vue&type=script&lang=js&"
export * from "./CourseSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c05b3476",
  null
  
)

export default component.exports